module.exports = __webpack_public_path__ + "static/img/crateCoin.5c2af7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/crateCoin.png
// module id = Yw7J
// module chunks = 1